export const OPERATOR_APPLICATION_LANGUAGE_RU = "ru";
export const OperatorApplicationDefaultLanguage = OPERATOR_APPLICATION_LANGUAGE_RU;

export const OperatorApplicationLanguagesList: { id: string, descr: string, locationDescr: "ru" | "en" }[] = [
    {
        id: OPERATOR_APPLICATION_LANGUAGE_RU,
        descr: "Русский",
        locationDescr: "ru"
    },
    {
        id: "ua",
        descr: "Український",
        locationDescr: "ru"
    },
    {
        id: "en",
        descr: "English",
        locationDescr: "en"
    },
    {
        id: "pt",
        descr: "Português",
        locationDescr: "en"
    }
];